import { Grid, Typography } from '@material-ui/core';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
} from 'data-layer-cr/dist/models';
import { Modal } from 'design-system';

// subcomponents
import { VehicleInformationCard } from '../../../../UnitSelection/components/InformationCards';
import DeductibleOptions from '../DeductibleOptions';

/** Properties passed tot he QuotationSummaryModal */
type Props = {
  open: boolean;
  quotation: Quotation;
  coverageCatalog: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  maxAllowedPayments: number;
  onCloseRequested: () => void;
};

// renders dynamic modal title with the given coverage type
function getModalTitle(coverage: string): JSX.Element {
  return (
    <Typography data-testid="modal-title" variant="body1" align="center">
      Cotización
      <br />
      {coverage}
    </Typography>
  );
}

const QuotationSummaryModal = ({
  open,
  quotation,
  coverageCatalog,
  coverageCatalogResumes,
  maxAllowedPayments,
  onCloseRequested,
}: Props): JSX.Element => {
  const { description } = quotation.summary;

  return (
    <Modal
      data-testid="modal"
      title={getModalTitle(description)}
      open={open}
      onCloseRequested={onCloseRequested}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <DeductibleOptions
            data-testid="deductible-card"
            quotation={quotation}
            coverageCatalogs={coverageCatalog}
            coverageCatalogResumes={coverageCatalogResumes}
            maxAllowedPayments={maxAllowedPayments}
          />
        </Grid>
        <Grid item xs={12}>
          <VehicleInformationCard
            data-testid="vehicle-information-card"
            quotation={quotation}
          />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default QuotationSummaryModal;
